/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetTermsheetForReviewQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetTermsheetForReviewQuery = { __typename?: 'Query', termsheet: { __typename?: 'Termsheet', id: number, updatedAt?: any | null, version?: number | null, terms: any, trade?: { __typename?: 'Trade', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null, bid?: { __typename?: 'Bid', id: number, status: Types.BidStatus, base: boolean, draft: boolean, bidType: Types.BidType, expiryTime?: any | null, updatedAt?: any | null, submittedAt?: any | null, termsheet?: { __typename?: 'Termsheet', id: number, version?: number | null } | null, submitter?: { __typename?: 'Company', id: number, name?: string | null } | null, activity: { __typename?: 'Activity', id: number, tradeCompany: { __typename?: 'TradeCompany', id: number, company: { __typename?: 'Company', id: number, name?: string | null }, trade: { __typename?: 'Trade', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } } } } | null } };

export type TermsheetForReviewDetailsFragment = { __typename?: 'Termsheet', id: number, updatedAt?: any | null, version?: number | null, terms: any, trade?: { __typename?: 'Trade', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null, bid?: { __typename?: 'Bid', id: number, status: Types.BidStatus, base: boolean, draft: boolean, bidType: Types.BidType, expiryTime?: any | null, updatedAt?: any | null, submittedAt?: any | null, termsheet?: { __typename?: 'Termsheet', id: number, version?: number | null } | null, submitter?: { __typename?: 'Company', id: number, name?: string | null } | null, activity: { __typename?: 'Activity', id: number, tradeCompany: { __typename?: 'TradeCompany', id: number, company: { __typename?: 'Company', id: number, name?: string | null }, trade: { __typename?: 'Trade', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } } } } | null };

export type TradeDataSubsetFragment = { __typename?: 'Trade', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null };

export type TradeMetaFragment = { __typename?: 'TradeMeta', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null };

export type GetReviewUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReviewUsersQuery = { __typename?: 'Query', getUsersWithTermsheetReviewPermissions: Array<{ __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null }> };

export type SubmitReviewMutationVariables = Types.Exact<{
  termsheetId: Types.Scalars['Float'];
  termsheetReview: Types.TermsheetReviewInput;
}>;


export type SubmitReviewMutation = { __typename?: 'Mutation', saveTermsheetReview: { __typename?: 'TermsheetReview', id: number } };

export type GetReviewsForPopupQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetReviewsForPopupQuery = { __typename?: 'Query', termsheetReviews: { __typename?: 'TermsheetReviewListResponse', data: Array<{ __typename?: 'TermsheetReview', id: number, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, createdAt?: any | null, bidSnapshot?: any | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null }> } };

export type ReviewListDataForPopupFragment = { __typename?: 'TermsheetReview', id: number, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, createdAt?: any | null, bidSnapshot?: any | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null };

export type GetReviewsQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetReviewsQuery = { __typename?: 'Query', termsheetReviews: { __typename?: 'TermsheetReviewListResponse', data: Array<{ __typename?: 'TermsheetReview', id: number, createdAt?: any | null, comment: string, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, bidSnapshot?: any | null, tradeSnapshot?: any | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null, tradeMeta?: { __typename?: 'TradeMeta', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type GetReviewMetricsQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetReviewMetricsQuery = { __typename?: 'Query', termsheetReviewMetrics: { __typename?: 'TermSheetReviewMetrics', supportedReviews: number, declinedReviews: number, pendingReviews: number } };

export type ReviewListDataFragment = { __typename?: 'TermsheetReview', id: number, createdAt?: any | null, comment: string, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, bidSnapshot?: any | null, tradeSnapshot?: any | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null, tradeMeta?: { __typename?: 'TradeMeta', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null };

export type GetReviewQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetReviewQuery = { __typename?: 'Query', termsheetReview: { __typename?: 'TermsheetReview', id: number, createdAt?: any | null, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, terms: any, baseTerms?: any | null, allowCompare?: boolean | null, tradeSnapshot?: any | null, bidSnapshot?: any | null, watch?: boolean | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null, tradeMeta?: { __typename?: 'TradeMeta', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null } };

export type ReviewDataFragment = { __typename?: 'TermsheetReview', id: number, createdAt?: any | null, termsheetReviewStatus: Types.TermsheetReviewStatus, reviewType: string, terms: any, baseTerms?: any | null, allowCompare?: boolean | null, tradeSnapshot?: any | null, bidSnapshot?: any | null, watch?: boolean | null, termsheetReviewUsers?: Array<{ __typename?: 'TermsheetReviewUser', id: number, user: { __typename?: 'User', id: number, firstName?: string | null, lastName?: string | null, name?: string | null } }> | null, tradeMeta?: { __typename?: 'TradeMeta', id: number, ref?: string | null, uid: string, tradeStatus: Types.TradeStatus, tradeType: Types.TradeType, transactionType: Types.TransactionType, currency?: Types.TradeCurrency | null, priceUnit?: string | null } | null };

export type GetReviewChatByCursorQueryVariables = Types.Exact<{
  reviewId: Types.Scalars['Int'];
  first?: Types.InputMaybe<Types.Scalars['Float']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetReviewChatByCursorQuery = { __typename?: 'Query', termsheetReviewChatsCursor: { __typename?: 'TermsheetReviewChatRelayResponse', page: { __typename?: 'TermsheetReviewChatConnection', edges?: Array<{ __typename?: 'TermsheetReviewChatEdge', cursor?: string | null, node?: { __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } } | null }> | null, pageInfo?: { __typename?: 'TermsheetReviewChatPageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } | null } } };

export type GetReviewChatQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetReviewChatQuery = { __typename?: 'Query', termsheetReviewChats: { __typename?: 'TermsheetReviewChatListResponse', data: Array<{ __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type SaveReviewMessageMutationVariables = Types.Exact<{
  termsheetReviewChat: Types.TermsheetReviewChatInput;
}>;


export type SaveReviewMessageMutation = { __typename?: 'Mutation', saveTermsheetReviewChat: { __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } } };

export type ReviewChatMessageConnectionPageFragment = { __typename?: 'TermsheetReviewChatConnection', edges?: Array<{ __typename?: 'TermsheetReviewChatEdge', cursor?: string | null, node?: { __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } } | null }> | null, pageInfo?: { __typename?: 'TermsheetReviewChatPageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } | null };

export type ReviewChatMessageDataFragment = { __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } };

export type ReviewTermsheetMutationVariables = Types.Exact<{
  termsheetReviewId: Types.Scalars['Int'];
  termsheetReviewStatus: Types.TermsheetReviewStatus;
}>;


export type ReviewTermsheetMutation = { __typename?: 'Mutation', reviewTermsheetReview: { __typename?: 'TermsheetReview', id: number, termsheetReviewStatus: Types.TermsheetReviewStatus } };

export type OnReviewChatSubscriptionVariables = Types.Exact<{
  termsheetReviewId: Types.Scalars['Int'];
}>;


export type OnReviewChatSubscription = { __typename?: 'Subscription', termsheetReviewChat: { __typename?: 'TermsheetReviewChat', id: number, createdAt?: any | null, updatedAt?: any | null, message: string, systemType?: Types.ReviewSystemMessageType | null, user: { __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null } } };

export type WatchTermsheetReviewMutationVariables = Types.Exact<{
  watch: Types.Scalars['Boolean'];
  termsheetReviewId: Types.Scalars['Int'];
}>;


export type WatchTermsheetReviewMutation = { __typename?: 'Mutation', watchTermsheetReview: { __typename?: 'TermsheetReview', id: number, watch?: boolean | null } };

export type OnReviewDetailsSubscriptionVariables = Types.Exact<{
  termsheetReviewId: Types.Scalars['Int'];
}>;


export type OnReviewDetailsSubscription = { __typename?: 'Subscription', termsheetReview: { __typename?: 'TermsheetReview', id: number, termsheetReviewStatus: Types.TermsheetReviewStatus } };

export const TradeDataSubsetFragmentDoc = gql`
    fragment TradeDataSubset on Trade {
  id
  ref
  uid
  tradeStatus
  tradeType
  transactionType
  currency
  priceUnit
}
    `;
export const TermsheetForReviewDetailsFragmentDoc = gql`
    fragment TermsheetForReviewDetails on Termsheet {
  id
  updatedAt
  version
  terms
  trade {
    ...TradeDataSubset
  }
  bid {
    id
    status
    base
    draft
    bidType
    expiryTime
    termsheet {
      id
      version
    }
    submitter {
      id
      name
    }
    updatedAt
    submittedAt
    activity {
      id
      tradeCompany {
        id
        company {
          id
          name
        }
        trade {
          ...TradeDataSubset
        }
      }
    }
  }
}
    ${TradeDataSubsetFragmentDoc}`;
export const ReviewListDataForPopupFragmentDoc = gql`
    fragment ReviewListDataForPopup on TermsheetReview {
  id
  termsheetReviewStatus
  reviewType
  createdAt
  bidSnapshot
  termsheetReviewUsers {
    id
    user {
      id
      firstName
      lastName
      name
    }
  }
}
    `;
export const TradeMetaFragmentDoc = gql`
    fragment TradeMeta on TradeMeta {
  id
  ref
  uid
  tradeStatus
  tradeType
  transactionType
  currency
  priceUnit
}
    `;
export const ReviewListDataFragmentDoc = gql`
    fragment ReviewListData on TermsheetReview {
  id
  createdAt
  comment
  termsheetReviewStatus
  reviewType
  bidSnapshot
  tradeSnapshot
  termsheetReviewUsers {
    id
    user {
      id
      firstName
      lastName
      name
    }
  }
  tradeMeta {
    ...TradeMeta
  }
}
    ${TradeMetaFragmentDoc}`;
export const ReviewDataFragmentDoc = gql`
    fragment ReviewData on TermsheetReview {
  id
  createdAt
  termsheetReviewStatus
  reviewType
  terms
  baseTerms
  allowCompare
  termsheetReviewUsers {
    id
    user {
      id
      firstName
      lastName
      name
    }
  }
  tradeMeta {
    ...TradeMeta
  }
  tradeSnapshot
  bidSnapshot
  watch
}
    ${TradeMetaFragmentDoc}`;
export const ReviewChatMessageDataFragmentDoc = gql`
    fragment ReviewChatMessageData on TermsheetReviewChat {
  id
  createdAt
  updatedAt
  message
  systemType
  user {
    id
    name
    firstName
    lastName
  }
}
    `;
export const ReviewChatMessageConnectionPageFragmentDoc = gql`
    fragment ReviewChatMessageConnectionPage on TermsheetReviewChatConnection {
  edges {
    cursor
    node {
      ...ReviewChatMessageData
    }
  }
  pageInfo {
    startCursor
    endCursor
    hasPreviousPage
    hasNextPage
  }
}
    ${ReviewChatMessageDataFragmentDoc}`;
export const GetTermsheetForReviewDocument = gql`
    query GetTermsheetForReview($query: JSON!) {
  termsheet(query: $query) {
    ...TermsheetForReviewDetails
  }
}
    ${TermsheetForReviewDetailsFragmentDoc}`;

export function useGetTermsheetForReviewQuery(options: Omit<Urql.UseQueryArgs<GetTermsheetForReviewQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTermsheetForReviewQuery>({ query: GetTermsheetForReviewDocument, ...options });
};
export const GetReviewUsersDocument = gql`
    query GetReviewUsers {
  getUsersWithTermsheetReviewPermissions {
    id
    name
    firstName
    lastName
  }
}
    `;

export function useGetReviewUsersQuery(options?: Omit<Urql.UseQueryArgs<GetReviewUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewUsersQuery>({ query: GetReviewUsersDocument, ...options });
};
export const SubmitReviewDocument = gql`
    mutation SubmitReview($termsheetId: Float!, $termsheetReview: TermsheetReviewInput!) {
  saveTermsheetReview(
    termsheetId: $termsheetId
    termsheetReview: $termsheetReview
  ) {
    id
  }
}
    `;

export function useSubmitReviewMutation() {
  return Urql.useMutation<SubmitReviewMutation, SubmitReviewMutationVariables>(SubmitReviewDocument);
};
export const GetReviewsForPopupDocument = gql`
    query GetReviewsForPopup($query: JSON!) {
  termsheetReviews(query: $query) {
    data {
      ...ReviewListDataForPopup
    }
  }
}
    ${ReviewListDataForPopupFragmentDoc}`;

export function useGetReviewsForPopupQuery(options: Omit<Urql.UseQueryArgs<GetReviewsForPopupQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewsForPopupQuery>({ query: GetReviewsForPopupDocument, ...options });
};
export const GetReviewsDocument = gql`
    query GetReviews($query: JSON!) {
  termsheetReviews(query: $query) {
    data {
      ...ReviewListData
    }
    pageData {
      count
      limit
    }
  }
}
    ${ReviewListDataFragmentDoc}`;

export function useGetReviewsQuery(options: Omit<Urql.UseQueryArgs<GetReviewsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewsQuery>({ query: GetReviewsDocument, ...options });
};
export const GetReviewMetricsDocument = gql`
    query GetReviewMetrics($query: JSON!) {
  termsheetReviewMetrics(query: $query) {
    supportedReviews
    declinedReviews
    pendingReviews
  }
}
    `;

export function useGetReviewMetricsQuery(options: Omit<Urql.UseQueryArgs<GetReviewMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewMetricsQuery>({ query: GetReviewMetricsDocument, ...options });
};
export const GetReviewDocument = gql`
    query GetReview($query: JSON!) {
  termsheetReview(query: $query) {
    ...ReviewData
  }
}
    ${ReviewDataFragmentDoc}`;

export function useGetReviewQuery(options: Omit<Urql.UseQueryArgs<GetReviewQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewQuery>({ query: GetReviewDocument, ...options });
};
export const GetReviewChatByCursorDocument = gql`
    query GetReviewChatByCursor($reviewId: Int!, $first: Float, $after: String) {
  termsheetReviewChatsCursor(
    query: {termsheetReview: {id: $reviewId}}
    sort: {createdAt: "DESC"}
    first: $first
    after: $after
  ) {
    page {
      ...ReviewChatMessageConnectionPage
    }
  }
}
    ${ReviewChatMessageConnectionPageFragmentDoc}`;

export function useGetReviewChatByCursorQuery(options: Omit<Urql.UseQueryArgs<GetReviewChatByCursorQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewChatByCursorQuery>({ query: GetReviewChatByCursorDocument, ...options });
};
export const GetReviewChatDocument = gql`
    query GetReviewChat($query: JSON!) {
  termsheetReviewChats(query: $query) {
    data {
      ...ReviewChatMessageData
    }
    pageData {
      count
      limit
    }
  }
}
    ${ReviewChatMessageDataFragmentDoc}`;

export function useGetReviewChatQuery(options: Omit<Urql.UseQueryArgs<GetReviewChatQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewChatQuery>({ query: GetReviewChatDocument, ...options });
};
export const SaveReviewMessageDocument = gql`
    mutation SaveReviewMessage($termsheetReviewChat: TermsheetReviewChatInput!) {
  saveTermsheetReviewChat(termsheetReviewChat: $termsheetReviewChat) {
    ...ReviewChatMessageData
  }
}
    ${ReviewChatMessageDataFragmentDoc}`;

export function useSaveReviewMessageMutation() {
  return Urql.useMutation<SaveReviewMessageMutation, SaveReviewMessageMutationVariables>(SaveReviewMessageDocument);
};
export const ReviewTermsheetDocument = gql`
    mutation ReviewTermsheet($termsheetReviewId: Int!, $termsheetReviewStatus: TermsheetReviewStatus!) {
  reviewTermsheetReview(
    termsheetReviewId: $termsheetReviewId
    termsheetReviewStatus: $termsheetReviewStatus
  ) {
    id
    termsheetReviewStatus
  }
}
    `;

export function useReviewTermsheetMutation() {
  return Urql.useMutation<ReviewTermsheetMutation, ReviewTermsheetMutationVariables>(ReviewTermsheetDocument);
};
export const OnReviewChatDocument = gql`
    subscription OnReviewChat($termsheetReviewId: Int!) {
  termsheetReviewChat(termsheetReviewId: $termsheetReviewId) {
    ...ReviewChatMessageData
  }
}
    ${ReviewChatMessageDataFragmentDoc}`;

export function useOnReviewChatSubscription<TData = OnReviewChatSubscription>(options: Omit<Urql.UseSubscriptionArgs<OnReviewChatSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OnReviewChatSubscription, TData>) {
  return Urql.useSubscription<OnReviewChatSubscription, TData, OnReviewChatSubscriptionVariables>({ query: OnReviewChatDocument, ...options }, handler);
};
export const WatchTermsheetReviewDocument = gql`
    mutation WatchTermsheetReview($watch: Boolean!, $termsheetReviewId: Int!) {
  watchTermsheetReview(watch: $watch, termsheetReviewId: $termsheetReviewId) {
    id
    watch
  }
}
    `;

export function useWatchTermsheetReviewMutation() {
  return Urql.useMutation<WatchTermsheetReviewMutation, WatchTermsheetReviewMutationVariables>(WatchTermsheetReviewDocument);
};
export const OnReviewDetailsDocument = gql`
    subscription OnReviewDetails($termsheetReviewId: Int!) {
  termsheetReview(termsheetReviewId: $termsheetReviewId) {
    id
    termsheetReviewStatus
  }
}
    `;

export function useOnReviewDetailsSubscription<TData = OnReviewDetailsSubscription>(options: Omit<Urql.UseSubscriptionArgs<OnReviewDetailsSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OnReviewDetailsSubscription, TData>) {
  return Urql.useSubscription<OnReviewDetailsSubscription, TData, OnReviewDetailsSubscriptionVariables>({ query: OnReviewDetailsDocument, ...options }, handler);
};